// extracted by mini-css-extract-plugin
export var header = "header-module--header--UabsJ";
export var logoImage = "header-module--logo-image--2GHvc";